if(checkIfExists('.featured-categories-slider')){
const swiper2 = new Swiper('.featured-categories-slider', {

  direction: 'horizontal',
  loop: true,
  lazy: true,
   slidesPerView: 4,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      430: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      700: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      950: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
  },

});
}



if(checkIfExists('.brands-slider')){
  const swiper3 = new Swiper('.brands-slider', {

  direction: 'horizontal',
  loop: true,
  lazy: true,
  autoplay: {
    delay: 2000,
  },
   slidesPerView: 6,
    breakpoints: {
      0: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      430: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      700: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      950: {
        slidesPerView: 6,
        spaceBetween: 50,
      },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
  },

});
}

